import React, { useEffect } from 'react';

const TawkToWidget: React.FC = () => {
  useEffect(() => {
    // Add the Tawk.to script to the DOM
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/668cc32bc3fb85929e3d0fb0/1i2atkomg';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.head.appendChild(script);

    // Clean up the script when the component is unmounted
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default TawkToWidget;